import React from "react";
import {
  Paper,
  Typography,
  TextField,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Button,
  InputAdornment,
  Chip,
  Stack,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

const ClientTable = ({
  searchTerm,
  setSearchTerm,
  rolFilter,
  setRolFilter,
  filtered,
  loading,
  page,
  setPage,
  rowsPerPage,
  setRowsPerPage,
  handleEdit,
  handleDeleteConfirm,
}) => {
  const renderRolChip = (p) => {
    const roles = [];
    if (p.es_cliente) roles.push("Cliente");
    if (p.es_proveedor) roles.push("Proveedor");
    if (p.es_empleado) roles.push("Empleado");
    if (roles.length === 0) return <Chip label="Sin rol" size="small" />;
    return <Chip label={roles.join(" / ")} size="small" />;
  };

  return (
    <Paper
      sx={{
        p: 3,
        borderRadius: "12px",
        boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
        bgcolor: "#FFFFFF",
      }}
    >
      <div className="row align-items-center mb-3">
        <div className="col-md-6 mb-2 mb-md-0">
          <TextField
            label="Buscar por nombre, cédula, RUC, teléfono o correo"
            variant="outlined"
            fullWidth
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon color="action" />
                </InputAdornment>
              ),
            }}
          />
        </div>
        <div className="col-md-6">
          <FormControl fullWidth>
            <InputLabel>Rol</InputLabel>
            <Select
              value={rolFilter}
              label="Rol"
              onChange={(e) => setRolFilter(e.target.value)}
            >
              <MenuItem value="todos">Todos</MenuItem>
              <MenuItem value="cliente">Clientes</MenuItem>
              <MenuItem value="proveedor">Proveedores</MenuItem>
              <MenuItem value="empleado">Empleados</MenuItem>
            </Select>
          </FormControl>
        </div>
      </div>

      <Typography variant="h6" sx={{ color: "#000", mb: 1 }}>
        Personas
      </Typography>

      <TableContainer>
        <Table stickyHeader size="small">
          <TableHead>
            <TableRow>
              <TableCell sx={{ bgcolor: "#1565C0", color: "#FFFFFF" }}>
                Razón social / Nombre
              </TableCell>
              <TableCell sx={{ bgcolor: "#1565C0", color: "#FFFFFF" }}>
                Identificación
              </TableCell>
              <TableCell sx={{ bgcolor: "#1565C0", color: "#FFFFFF" }}>
                Rol
              </TableCell>
              <TableCell sx={{ bgcolor: "#1565C0", color: "#FFFFFF" }}>
                Teléfono
              </TableCell>
              <TableCell sx={{ bgcolor: "#1565C0", color: "#FFFFFF" }}>
                Acción
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {loading ? (
              <TableRow>
                <TableCell colSpan={5} align="center">
                  <CircularProgress size={24} />
                </TableCell>
              </TableRow>
            ) : filtered.length === 0 ? (
              <TableRow>
                <TableCell colSpan={5} align="center">
                  No hay personas para mostrar.
                </TableCell>
              </TableRow>
            ) : (
              filtered
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((p) => (
                  <TableRow key={p.id} hover>
                    <TableCell>
                      <div style={{ fontWeight: 600 }}>{p.razon_social}</div>
                      {p.nombre_comercial && (
                        <div style={{ fontSize: 12, color: "#666" }}>
                          {p.nombre_comercial}
                        </div>
                      )}
                    </TableCell>

                    <TableCell>
                      {p.cedula && <div>Cédula: {p.cedula}</div>}
                      {p.ruc && <div>RUC: {p.ruc}</div>}
                      {!p.cedula && !p.ruc && <div>-</div>}
                    </TableCell>

                    <TableCell>{renderRolChip(p)}</TableCell>

                    <TableCell>{p.telefono || "-"}</TableCell>

                    <TableCell>
                      <Stack direction="row" spacing={1}>
                        <Button
                          variant="contained"
                          sx={{
                            textTransform: "none",
                            bgcolor: "#1565C0",
                            color: "#fff",
                            "&:hover": { bgcolor: "#0D47A1" },
                          }}
                          onClick={() => handleEdit(p)}
                        >
                          Editar
                        </Button>
                        <Button
                          variant="contained"
                          sx={{
                            textTransform: "none",
                            bgcolor: "#D32F2F",
                            color: "#fff",
                            "&:hover": { bgcolor: "#B71C1C" },
                          }}
                          onClick={() => handleDeleteConfirm(p.id)}
                        >
                          Eliminar
                        </Button>
                      </Stack>
                    </TableCell>
                  </TableRow>
                ))
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <TablePagination
        component="div"
        count={filtered.length}
        page={page}
        onPageChange={(e, newPage) => setPage(newPage)}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={(e) =>
          setRowsPerPage(parseInt(e.target.value, 10))
        }
      />
    </Paper>
  );
};

export default ClientTable;
